var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detail.content)?_c('div',{staticClass:"seo-content-detail"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.detail.title))]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }